import { isNil, path } from 'ramda';

import { GridValueGetterParams } from '@mui/x-data-grid-pro';
import { GridValueFormatterParams } from '@mui/x-data-grid-pro';

import { formatByLocale } from './date';
import { displayNumber } from './misc';
import dayjs from 'dayjs';

export const nestedFieldValueGetter = (params: GridValueGetterParams) => {
  const { row, field } = params;
  return path(field.split('.'), row);
};

export const booleanValueGetter = (params: GridValueGetterParams): boolean => {
  const { row, field } = params;
  return !!row.flags?.includes(field);
};

export const numberFormatter = (params: GridValueFormatterParams): string => {
  const { value } = params;
  return displayNumber(value);
};

export const dateFormatter = (
  params: GridValueFormatterParams
): string | undefined => {
  const { value } = params;
  if (isNil(value) || !dayjs(value).isValid()) return;
  return formatByLocale(new Date(value));
};

export const dateAndTimeFormatter = (
  params: GridValueFormatterParams
): string | undefined => {
  const { value } = params;
  if (isNil(value) || !dayjs(value).isValid()) return;

  return dayjs(value).format('DD-MM-YYYY HH:mm');
};

export const defaultDateFormatter = (
  params: GridValueFormatterParams
): string | undefined => {
  const { value } = params;
  if (isNil(value) || !dayjs(value).isValid()) return;

  return dayjs(value).format('DD-MM-YYYY');
};

export const fullDateFormatter = (
  params: GridValueFormatterParams
): string | undefined => {
  const { value } = params;
  if (isNil(value)) return;
  return formatByLocale(new Date(value), 'dd MMMM yyyy');
};
